import DeleteIcon from "@mui/icons-material/Delete";
import Select from "react-select";

export const AuthorizedTab = ({
    purchaseData,
    setPurchaseData,
    chequeData,
    setChequeData,
    errors,
    setErrors,
    handleTabChange,
    countryList
}) => {

    const addPurchaseOrderRow = () => {
        setPurchaseData([
            ...purchaseData,
            { name: "", designation: "", nationality: null, eid_no: "" },
        ]);
    };

    const removePurchaseRow = (index) => {
        if (purchaseData.length > 1) {
            setPurchaseData(purchaseData.filter((_, i) => i !== index));
        }
    };

    const handlePurchaseChange = (index, field, value) => {
        const updated = purchaseData.map((row, i) =>
            i === index ? { ...row, [field]: value } : row
        );
        setPurchaseData(updated);

        const errorKey = `purchase_${field}_${index}`;
        if (errors[errorKey]) {
            setErrors(prevErrors => ({
                ...prevErrors,
                [errorKey]: ""
            }));
        }
    };

    /* ---------------- CHEQUES ---------------- */

    const addChequeRow = () => {
        setChequeData([
            ...chequeData,
            { name: "", designation: "", nationality: null, eid_no: "" },
        ]);
    };

    const removeChequeRow = (index) => {
        if (chequeData.length > 1) {
            setChequeData(chequeData.filter((_, i) => i !== index));
        }
    };

    const handleChequeChange = (index, field, value) => {
        const updated = chequeData.map((row, i) =>
            i === index ? { ...row, [field]: value } : row
        );
        setChequeData(updated);

        const errorKey = `cheque_${field}_${index}`;
        if (errors[errorKey]) {
            setErrors(prevErrors => ({
                ...prevErrors,
                [errorKey]: ""
            }));
        }
    };

    return (
        <div className="tab-pane fade show active">

            {/* ---------------- Purchase Orders ---------------- */}
            <div className="mb-5">
                <h6 className="border-bottom pb-2 mb-3">Person authorised to purchase orders</h6>

                {purchaseData.map((order, index) => (
                    <div key={index} className="border p-3 mb-3 position-relative rounded">

                        {purchaseData.length > 1 && (
                            <button
                                type="button"
                                className="btn btn-outline-danger btn-sm position-absolute"
                                style={{ top: "8px", right: "8px" }}
                                onClick={() => removePurchaseRow(index)}
                            >
                                <DeleteIcon fontSize="small" />
                            </button>
                        )}

                        <div className="row mt-2">
                            <div className="col-md-6">
                                <label>Name {index + 1} *</label>
                                <input
                                    className={`form-control ${errors[`purchase_name_${index}`] ? "is-invalid" : ""}`}
                                    value={order.name}
                                    onChange={(e) =>
                                        handlePurchaseChange(index, "name", e.target.value)
                                    }
                                />
                                {errors[`purchase_name_${index}`] && (
                                    <div className="invalid-feedback">
                                        {errors[`purchase_name_${index}`]}
                                    </div>
                                )}
                            </div>

                            <div className="col-md-6">
                                <label>Designation *</label>
                                <input
                                    className={`form-control ${errors[`purchase_designation_${index}`] ? "is-invalid" : ""}`}
                                    value={order.designation}
                                    onChange={(e) =>
                                        handlePurchaseChange(index, "designation", e.target.value)
                                    }
                                />
                                {errors[`purchase_designation_${index}`] && (
                                    <div className="invalid-feedback">
                                        {errors[`purchase_designation_${index}`]}
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="row mt-2">
                            <div className="col-md-6">
                                <label>Nationality *</label>
                                <Select
                                    isClearable
                                    options={countryList}                 
                                    value={order.nationality}
                                    onChange={(selectedOption) => {
                                        setPurchaseData(prev => {
                                            const updated = [...prev];
                                            updated[index] = {
                                                ...updated[index],
                                                nationality: selectedOption
                                            };
                                            return updated;
                                        });

                                        const errorKey = `purchase_nationality_${index}`;
                                        if (errors[errorKey]) {
                                            setErrors(prev => ({
                                                ...prev,
                                                [errorKey]: ""
                                            }));
                                        }
                                    }}
                                    classNamePrefix="react-select"
                                    className={errors[`purchase_nationality_${index}`] ? "is-invalid" : ""}
                                />
                                {errors[`purchase_nationality_${index}`] && (
                                    <div className="text-danger d-block">
                                        {errors[`purchase_nationality_${index}`]}
                                    </div>
                                )}
                            </div>

                            <div className="col-md-6">
                                <label>Emirates ID Number *</label>
                                <input
                                    className={`form-control ${errors[`purchase_eid_no_${index}`] ? "is-invalid" : ""}`}
                                    value={order.eid_no}
                                    onChange={(e) =>
                                        handlePurchaseChange(index, "eid_no", e.target.value)
                                    }
                                />
                                {errors[`purchase_eid_no_${index}`] && (
                                    <div className="invalid-feedback">
                                        {errors[`purchase_eid_no_${index}`]}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                ))}

                <button
                    type="button"
                    className="btn btn-outline-primary btn-sm"
                    onClick={addPurchaseOrderRow}
                >
                    + Add Another Purchase Order
                </button>
            </div>

            {/* ---------------- Cheques ---------------- */}
            <div className="mb-5">
                <h6 className="border-bottom pb-2 mb-3">Check Signatory Details</h6>

                {chequeData.map((cheque, index) => (
                    <div key={index} className="border p-3 mb-3 position-relative rounded">

                        {chequeData.length > 1 && (
                            <button
                                type="button"
                                className="btn btn-outline-danger btn-sm position-absolute"
                                style={{ top: "8px", right: "8px" }}
                                onClick={() => removeChequeRow(index)}
                            >
                                <DeleteIcon fontSize="small" />
                            </button>
                        )}

                        <div className="row mt-2">
                            <div className="col-md-6">
                                <label>Name {index + 1} *</label>
                                <input
                                    className={`form-control ${errors[`cheque_name_${index}`] ? "is-invalid" : ""}`}
                                    value={cheque.name}
                                    onChange={(e) =>
                                        handleChequeChange(index, "name", e.target.value)
                                    }
                                />
                                {errors[`cheque_name_${index}`] && (
                                    <div className="invalid-feedback d-block">
                                        {errors[`cheque_name_${index}`]}
                                    </div>
                                )}
                            </div>

                            <div className="col-md-6">
                                <label>Designation *</label>
                                <input
                                    className={`form-control ${errors[`cheque_designation_${index}`] ? "is-invalid" : ""}`}
                                    value={cheque.designation}
                                    onChange={(e) =>
                                        handleChequeChange(index, "designation", e.target.value)
                                    }
                                />
                                {errors[`cheque_designation_${index}`] && (
                                    <div className="invalid-feedback d-block">
                                        {errors[`cheque_designation_${index}`]}
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="row mt-2">
                            <div className="col-md-6">
                                <label>Nationality *</label>
                                <Select
                                    isClearable
                                    options={countryList}
                                    value={cheque.nationality}
                                    onChange={(selectedOption) => {
                                        setChequeData(prev => {
                                            const updated = [...prev];
                                            updated[index] = {
                                                ...updated[index],
                                                nationality: selectedOption
                                            };
                                            return updated;
                                        });

                                        const errorKey = `cheque_nationality_${index}`;
                                        if (errors[errorKey]) {
                                            setErrors(prev => ({
                                                ...prev,
                                                [errorKey]: ""
                                            }));
                                        }
                                    }}
                                    classNamePrefix="react-select"
                                    className={errors[`cheque_nationality_${index}`] ? "is-invalid" : ""}
                                />
                                {errors[`cheque_nationality_${index}`] && (
                                    <div className="text-danger d-block">
                                        {errors[`cheque_nationality_${index}`]}
                                    </div>
                                )}
                            </div>

                            <div className="col-md-6">
                                <label>Emirates ID Number *</label>
                                <input
                                    className={`form-control ${errors[`cheque_eid_no_${index}`] ? "is-invalid" : ""}`}
                                    value={cheque.eid_no}
                                    onChange={(e) =>
                                        handleChequeChange(index, "eid_no", e.target.value)
                                    }
                                />
                                {errors[`cheque_eid_no_${index}`] && (
                                    <div className="invalid-feedback d-block">
                                        {errors[`cheque_eid_no_${index}`]}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                ))}

                <button
                    type="button"
                    className="btn btn-outline-primary btn-sm"
                    onClick={addChequeRow}
                >
                    + Add Another Details
                </button>
            </div>

            {/* Navigation */}
            <div className="d-flex justify-content-end mt-4">
                <button
                    type="button"
                    className="btn btn-dark btn-sm mr-2"
                    onClick={() => handleTabChange("owner")}
                >
                    Back
                </button>
                <button
                    type="button"
                    className="btn btn-info btn-sm"
                    onClick={() => handleTabChange("trade")}
                >
                    Next
                </button>
            </div>
        </div>
    );
};
